import { createComponent } from '@mtfe/sweet';

import tpl from './dom.html';
import style from './style.less';
import { COUPON_STATUS } from '../../constants/index';

const CouponInfo = (props = {}) => {
    try {
        const { poiInfo } = props;
        const { onCouponBtnClick, onPoiInfoClick } = props;

        const { giftInfo } = poiInfo;
        const { status } = giftInfo;

        const isNewCoupon = status === COUPON_STATUS.STATUS_NEW;
        const data = {
            poiInfo,
            isNewCoupon,
        };
        const events = {
            onCouponBtnClick: () => {
                onCouponBtnClick && onCouponBtnClick(poiInfo);
                return false;
            },
            onPoiInfoClick: () => {
                onPoiInfoClick && onPoiInfoClick(poiInfo);
            },
        };
        const component = createComponent(tpl, { data, style }, events);
        return component;
    } catch (error) {
        console.error(error);
        return '';
    }
};

export default CouponInfo;
